import React from 'react';
import { HudIcon } from '../Icons/HudIcons';
import Tooltip from '../Tooltip/Tooltip';
import { thirdPartyModulesConfig } from './thirdPartyModulesConfig';
import styled from 'styled-components';
export interface ModuleIconProps {
  thirdPartyModule?: string;
  className?: string;
  size?: string;
  withTooltip?: boolean;
}

export const ModuleIcon: React.FC<ModuleIconProps> = ({
  thirdPartyModule,
  className,
  size = '16px',
  withTooltip = true,
}) => {
  const isThirdParty = thirdPartyModule && thirdPartyModulesConfig[thirdPartyModule];
  const icon = isThirdParty ? thirdPartyModulesConfig[thirdPartyModule].icon : 'other.codeBrackets';
  const description = isThirdParty ? thirdPartyModulesConfig[thirdPartyModule].display : 'Function';
  if (withTooltip) {
    return (
      <Tooltip className={className} description={description} openDelay={0}>
        <CenteredHudIcon icon={icon} size={size} />
      </Tooltip>
    );
  }
  return <CenteredHudIcon icon={icon} size={size} />;
};

const CenteredHudIcon = styled(HudIcon)`
  display: flex;
  align-items: center;
`;